import type { GameStateManager } from '../game/GameState';
import type { GameData, GameEndResult } from '../game/types';
import { AudioManager } from '../audio/AudioManager';

export class WinModal {
  private audioManager: AudioManager;

  constructor(
    private container: HTMLElement,
    private gameState: GameStateManager,
    private gameData: GameData,
    private onNewGame: () => void
  ) {
    this.audioManager = AudioManager.getInstance();
    this.setup();
  }

  private setup(): void {
    // No backdrop click handling - modal cannot be dismissed
  }

  show(result: GameEndResult): void {
    const { title, message } = this.getVictoryContent(result.reason);
    
    this.container.innerHTML = `
      <div class="modal-backdrop modal-backdrop-no-dismiss"></div>
      <div class="modal-content win-modal" tabindex="0">
        <div class="modal-header">
          <h2>${title}</h2>
        </div>
        <div class="modal-body">
          <div class="win-message">
            ${message}
          </div>
        </div>
        <div class="modal-footer">
          <button class="button-confirm" data-action="new-game">New Game</button>
        </div>
      </div>
    `;

    // Attach new game button handler
    const newGameButton = this.container.querySelector('[data-action="new-game"]') as HTMLElement;
    if (newGameButton) {
      newGameButton.addEventListener('click', () => {
        this.audioManager.playClick();
        this.hide();
        this.onNewGame();
      });
    }

    this.container.classList.remove('hidden');
    this.gameState.setPausedByModal(true);
    
    this.audioManager.playEffect();
    
    const modalContent = this.container.querySelector('.modal-content') as HTMLElement;
    if (modalContent) {
      modalContent.focus();
    }
  }

  hide(): void {
    this.container.classList.add('hidden');
    this.gameState.setPausedByModal(false);
  }

  isOpen(): boolean {
    return !this.container.classList.contains('hidden');
  }

  private getVictoryContent(reason: 'wealth' | 'solved' | 'budget' | 'researchers'): { title: string; message: string } {
    switch (reason) {
      case 'wealth':
        return this.gameData.gameEndData.victory_wealth;
      case 'solved':
        return this.gameData.gameEndData.victory_solved;
      default:
        return { title: 'Victory', message: 'You have won the game!' };
    }
  }
}

